<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)" :updataID='updataID'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import QyzsAdd from '../../../../../static/form/xsyz/QyzsAdd'
export default {
  components: {
    QyzsAdd
  },
  data()
  {
    return {
      updataID: this.$route.query.id,
      editableTabsValue: '1',
      editableTabs: [{
        title: '公司信息',
        name: '1',
        closable: false,
        content: QyzsAdd
      }]
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/xsyzgl/QyzsLook.vue